'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-0.000172973 2C-0.000172973 0.895435 -0.000219703 0 -0.000219703 0L27.9998 3.99724e-06C27.9998 6.66667 27.9998 13.3333 27.9998 20C19.3332 20 10.6665 20 1.99983 20C0.895259 20 -5.09023e-05 20 -5.09023e-05 20L-0.000172973 2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-0.000219703 0L27.9998 3.99724e-06V20H-5.09023e-05L-0.000219703 0Z",
          fill: "#08C55F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-5.09023e-05 20L-0.000219703 0L27.9997 9.33334V10.6667L-5.09023e-05 20Z",
          fill: "#FFD831"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-0.000335693 18.5945L25.7833 10L-0.000335693 1.40546V18.5945ZM27.9997 10.6667L-5.09023e-05 20L-0.000219703 0L27.9997 9.33334V10.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-5.09023e-05 20L-0.000219703 0L15.333 10L-5.09023e-05 20Z",
          fill: "#E92034"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-0.000335693 18.4082L12.8922 10L-0.000335693 1.59183V18.4082ZM15.333 10L-5.09023e-05 20L-0.000219703 0L15.333 10Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagGyAsset = forwardRef(FlagGyAsset);

export { VpFlagGyAsset as default };
